module.exports = __webpack_public_path__ + "img/inco6Ac.3cee228d.png";